import React from 'react';
import icon from '../../../../../../assets/icons/charts/zoomAndFilter/icon_bubble_chart.svg';
import SVG from "react-inlinesvg";

const IconBubbleChart = () => (
    <SVG src={icon}  height={40} style = {{ marginTop: 10}} />
);
export default IconBubbleChart;